import { API } from '@utils/axios'

export async function fetchAffiliateList (params: any) {
  const response = await API.get('/Affiliate', { params })
  return response.data
}

export async function fetchAffiliateById (id: string) {
  const response = await API.get(`/Affiliate/${id}`)
  return response.data
}

export async function addAffiliate (data: any) {
  const response = await API.post('/Affiliate', data)
  return response.data
}

export async function updateAffiliate (data: any) {
  const response = await API.put('/Affiliate', data)
  return response.data
}

export async function deleteAffiliate (id: string) {
  const response = await API.delete(`/Affiliate/${id}`)
  return response.data
}
